import React from 'react'
import crm from '../project/crm.png'
import gps from '../project/gps.png'
import funzo from '../project/funzo.png'
import banscan from '../project/banscan.png'


const Resumescreen = () => {
    return (
        <div className="container-fluid p-4" id="maindiv">
            <h2 className="text-start fw-bold" style={{ color: "skyblue" }}>Resume </h2>

            <div className="container my-2" id="resume_timelines">
                <br />
                <div className="row">
                    <div className="col-md-6">
                        <h5 className="text-start fw-bold text-white">Education</h5>

                        <div className="card text-white" style={{ backgroundColor: "#222" }}>
                            <div className="card-body">
                                <div id="content">
                                    <ul className="timeline">
                                        <li className="event" data-date="2022 - 2025">
                                            <h3>M Tech CS</h3>
                                            <p>AMITY University, Noida, India</p>
                                        </li>
                                        <li className="event" data-date="2018 - 2022">
                                            <h3>B Tech CS (CSF)</h3>
                                            <p>GLA University, Mathura, India</p>
                                        </li>
                                        <li className="event" data-date="2017 - 2018">
                                            <h3>Intermediate</h3>
                                            <p>Kendriya Vidyalaya</p>
                                        </li>
                                        <li className="event" data-date="2015 - 2016">
                                            <h3>High School</h3>
                                            <p>Kendriya Vidyalaya</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 text-start">
                        <h5 className="text-start fw-bold text-white">Professional <span style={{ color: "skyblue" }}>Skills</span></h5>
                        <br />
                        <div className="col my-2">
                            <small className="text-white">Teamwork</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "100%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div>
                            </div>
                        </div>

                        <div className="col my-2">
                            <small className="text-white">Creative Thinking</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "100%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div>
                            </div>
                        </div>

                        <div className="col my-2">
                            <small className="text-white">Analytical Thinking</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "80%" }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">80%</div>
                            </div>
                        </div>

                        <div className="col my-2">
                            <small className="text-white">Leadership</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "80%" }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">75%</div>
                            </div>
                        </div>

                    </div>
                </div>

                <br />
                <div className="row">
                    <div className="col-md-6 text-start">
                        <h5 className="text-start fw-bold text-white">Technical <span style={{ color: "skyblue" }}>Skills</span></h5>
                        <br />

                        <div className="col my-2">
                            <small className="text-white">ServiceNow</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "85%" }} aria-valuenow="85" aria-valuemin="0" aria-valuemax="100">85%</div>
                            </div>
                        </div>
                        <div className="col my-2">
                            <small className="text-white">HTML / CSS </small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "100%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div>
                            </div>
                        </div>
                        <div className="col my-2">
                            <small className="text-white">JavaScript / jQuery</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "85%" }} aria-valuenow="85" aria-valuemin="0" aria-valuemax="85">85%</div>
                            </div>
                        </div>
                        <div className="col my-2">
                            <small className="text-white">React JS</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "80%" }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="80">80%</div>
                            </div>
                        </div>
                        <div className="col my-2">
                            <small className="text-white">Node / Express JS</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "80%" }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="80">80%</div>
                            </div>
                        </div>
                        <div className="col my-2">
                            <small className="text-white">Python / Django</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "80%" }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="80">80%</div>
                            </div>
                        </div>
                        <div className="col my-2">
                            <small className="text-white">PHP / CodeIgniter</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "85%" }} aria-valuenow="85" aria-valuemin="0" aria-valuemax="85">85%</div>
                            </div>
                        </div>
                        <div className="col my-2">
                            <small className="text-white">Flutter</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "85%" }} aria-valuenow="85" aria-valuemin="0" aria-valuemax="85">85%</div>
                            </div>
                        </div>

                        <div className="col my-2">
                            <small className="text-white">C / C++</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "60%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="60">60%</div>
                            </div>
                        </div>

                        <div className="col my-2">
                            <small className="text-white">Java</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "65%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="65">65%</div>
                            </div>
                        </div>

                        <div className="col my-2">
                            <small className="text-white">MYSQL, SQLITE3, MONGODB</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "90%" }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="90">90%</div>
                            </div>
                        </div>

                        <div className="col my-2">
                            <small className="text-white">Rest API</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "100%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">90%</div>
                            </div>
                        </div>

                        <div className="col my-2">
                            <small className="text-white">GIT / VCS</small>
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "60%" }} aria-valuenow="60" aria-valuemin="0" aria-valuemax="50">60%</div>
                            </div>
                        </div>

                    </div>


                    <div className="col-md-6">
                        <h5 className="text-start fw-bold text-white">Working Experience</h5>

                        <div className="card text-white" style={{ backgroundColor: "#222" }}>
                            <div className="card-body">
                                <div id="content">
                                    <ul className="timeline">
                                    <li className="event" data-date="June 2022 - Current">
                                            <h3>ACCENTURE</h3>
                                            <p>Application Development Analyst</p>
                                        </li>
                                        <li className="event" data-date="Oct 2021 - May 2022">
                                            <h3>Emoha</h3>
                                            <p>Backend Developer</p>
                                        </li>
                                        <li className="event" data-date="May 2021 - Sep 2021">
                                            <h3>SIKARWAR SOFTWARES</h3>
                                            <p>Full Stack Developer</p>
                                        </li>
                                        
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <br />
                <br />

                <div className="row my-4 p-2">
                    <h5 className="text-start fw-bold" style={{ color: "skyblue" }}>PROJECTS</h5>


                    <div className="card col-sm m-3">
                        <div className="row g-0">
                            <div className="col-md-4">
                                <img src={funzo} className="img-fluid rounded-start" alt="CRM" />
                            </div>
                            <div className="col-md-8">
                                <div className="card-body">
                                    <h5 className="card-title fw-bold">Funzo</h5>
                                    <p className="card-text">Clone of DUNZO application</p>
                                    <p className="card-text"><small className="text-muted">PHP, CodeIgniter</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card col-sm m-3">
                        <div className="row g-0">
                            <div className="col-md-4">
                                <img src={banscan} className="img-fluid rounded-start" alt="CRM" />
                            </div>
                            <div className="col-md-8">
                                <div className="card-body">
                                    <h5 className="card-title fw-bold">Ban Scan</h5>
                                    <p className="card-text">Android Application for Indian Army</p>
                                    <p className="card-text"><small className="text-muted">Flutter, MongoDB</small></p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="row my-4 p-2">
                    <div className="card col-sm m-3">
                        <div className="row g-0">
                            <div className="col-md-4">
                                <img src={crm} className="img-fluid rounded-start" alt="CRM" />
                            </div>
                            <div className="col-md-8">
                                <div className="card-body">
                                    <h5 className="card-title fw-bold">CRM APPLICATION</h5>
                                    <p className="card-text">Customer relationship management Web Application</p>
                                    <p className="card-text"><small className="text-muted">Python, Django</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card col-sm m-3">
                        <div className="row g-0">
                            <div className="col-md-4">
                                <img src={gps} className="img-fluid rounded-start" alt="CRM" />
                            </div>
                            <div className="col-md-8">
                                <div className="card-body">
                                    <h5 className="card-title fw-bold">GEO MARK</h5>
                                    <p className="card-text">Attedance management web application</p>
                                    <p className="card-text"><small className="text-muted">React.js, Node.js</small></p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>



        </div>
    )
}

export default Resumescreen
